import { render, staticRenderFns } from "./Comp4t3.vue?vue&type=template&id=899ca30c&scoped=true&"
import script from "./Comp4t3.vue?vue&type=script&lang=js&"
export * from "./Comp4t3.vue?vue&type=script&lang=js&"
import style0 from "./Comp4t3.vue?vue&type=style&index=0&id=899ca30c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899ca30c",
  null
  
)

export default component.exports